<ng-container *ngIf="v2; else v1Button">
	<button
		type="button"
		class="open-location-button-v2"
		[class.open-location-button-v2--tonal]="tonal"
		[disabled]="(canOpen$ | async) !== true"
		(click)="openLocation()"
	>
		<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
			lock
		</span>
		{{ "LOCATION_CLOSED_V2__OPEN_RIDE" | transloco }}
	</button>
</ng-container>

<ng-template #v1Button>
	<ion-button shape="round" color="primary" class="open-button" (click)="openLocation()">
		<ion-icon slot="start" name="lock-open-outline"></ion-icon>
		{{ "READY__OPEN" | transloco }}
	</ion-button>
</ng-template>
